import React,{useEffect,useRef,useState} from 'react'
import './contact.css'
import emailjs from 'emailjs-com'; // Import emailjs-com

import "jquery";
import "bootstrap/dist/js/bootstrap.js";
import "popper.js/dist/umd/popper";
import "bootstrap/dist/css/bootstrap.css";
export default function Contact() {
    const aboutUsRef = useRef(null);
   
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: ''
    });
const [show,setShow]= useState(false)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    const [load,setLoad]= useState(false)

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoad(true)
        // Send email using EmailJS
        emailjs.send(
            'service_qucoi14',
            'template_3wveuz6',
            { 
               email:formData.email,
               firstName:formData.firstName,
               lastName:formData.lastName,
               message:formData.message
            },
            'v7Slyc_tsd75zB52s'
        ).then(
            (result) => {
                console.log(result.text);
               
                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    message: ''
                });
                setShow(true);
            setTimeout(() => setShow(false), 5000);
            setLoad(false)
            },
            (error) => {
                console.log(error.text);
                alert('Error sending email.');
                setLoad(false)

            }
        );
    };
    useEffect(() => {
      
        window.scrollTo(0, 0);
      }, []);
      
  return (
    <div>
       <span>
       {show && (
                <div className="thought">
                    Thoughts Submitted Successfully
                    <div className="progress-line"></div>
                </div>
            )}
        </span>
        <div className="image-section-con first-section-con">
                <div class="carousel-overlay-img"></div>
                <div className="animate one">
        <span>C</span><span>O</span><span>N</span><span>T</span><span>A</span><span>C</span><span>T</span> &nbsp;
        <span>U</span><span>S</span>
      </div>                 </div>
            <div ref={aboutUsRef} className="content-container">

<div className="right-content1 -ch" >
    <img src='https://media.gettyimages.com/id/1314210994/photo/happy-little-boy-sitting-on-the-bed-in-a-packed-donation-box.jpg?s=612x612&w=0&k=20&c=iNwmknpIAa7p_0m6Pb8_RP2YrpJkTaeM87aczCQhUJ4=' alt="Right side image" />

</div>

<div className="right-content">
<div className="grid-container-con">
    {/* First Row */}
    <div className="grid-item-con">
      
    <div className="box">
     <center> <p><img style={{width:'80px'}}src="data:image/png;base64,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" alt="Image 2" className="grid-image-con" /></p><p>Visit Us Here</p>
    <a style={{textDecoration:'none'}} href='https://www.google.com/maps/place/1%2F257,+Natesan+St,+near+Natesan+Palace,+%5Bno+name%5D,+Vandalur,+Tamil+Nadu+600048/@12.8935473,80.0817075,17z/data=!3m1!4b1!4m6!3m5!1s0x3a52f5e287917dd5:0x111c53428ffc45e6!8m2!3d12.8935473!4d80.0842824!16s%2Fg%2F11rkbdnm8p?entry=ttu'>  <p>1/260 B ,Natesan street, Vandalur, Chennai: 600048</p></a></center></div>
      </div>

    {/* Second Row */}
    <div className="grid-item-con">
     
    <div className="box">
     <center> <p><img style={{width:'80px'}}src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTOk07yMLAHloN4wv50MoK1dXufTAPpDuCIQ&s" alt="Image 2" className="grid-image-con" /></p><p>Call Us</p>
      <p> <a style={{textDecoration:'none'}} href="tel:+9791173137">9791173137</a>,
    <a style={{textDecoration:'none'}} href="tel:+8925981601">8925981601</a></p></center></div>
      </div>

    {/* Third Row */}
    <div className="grid-item-con">
      
    <div className="box">
     <center> <p><img style={{width:'80px'}}src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-4uS-LJvm6CKsfIHqqZpZ2PIsZPp_HHbK7Q&s" alt="Image 2" className="grid-image-con" /></p><p>Mail Us</p>
      <p > <a style={{textDecoration:'none'}} href="mailto:indianwelfarefoundation03@gmail.com">indianwelfarefoundation03@gmail.com</a></p></center></div>
      </div>
  </div>
</div>
</div>
  <div ref={aboutUsRef} className="content-container">

  <div className="left-content">
  <div style={{ maxWidth: '600px', margin: '0 auto', padding: '20px', boxShadow: '0px 0px 10px #ccc' }}>
            <form onSubmit={handleSubmit}>
                <center><p style={{fontSize:'20px',fontWeight:'bold'}}>Raise Your Thoughts</p></center>
                <div className='msg'>
                <div  style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                    <input
                        type="text"
                        name="firstName"
                        className='in'
                        value={formData.firstName}
                        onChange={handleChange}
                        placeholder="First Name"
                        style={{ flex: '1', marginRight: '10px',height:'40px',borderRadius:'5px',borderWidth:'2px' }}
                        required
                    />
                    <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        className='in'
                        placeholder="Last Name"
                        style={{ flex: '1', marginLeft: '10px',height:'40px',borderRadius:'5px' }}
                        required
                    />
                </div></div>
                <div style={{ marginBottom: '20px' }}>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email"
                        style={{ width: '100%' ,height:'40px',borderRadius:'5px'}}
                        required
                    />
                </div>
                <div style={{ marginBottom: '20px' }}>
                    <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Your Message"
                        style={{ width: '100%', height: '150px',borderRadius:'5px' }}
                        required
                    />
                </div>
                <button type="submit" style={{ width: '30%', padding: '10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px' }}>
                  {  load ? (
           <center>  <div className="loading-spinner"></div></center>   
                  ):(
                   <h6>send</h6>
                  )}
                </button>
            </form>
        </div> 
  </div>
  
  <div className="map">
  <iframe 
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.475580729952!2d80.0817075!3d12.8935473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52f5e287917dd5%3A0x111c53428ffc45e6!2s1%2F257%2C%20Natesan%20St%2C%20near%20Natesan%20Palace%2C%20Vandalur%2C%20Tamil%20Nadu%20600048!5e0!3m2!1sen!2sin!4v1586934945234!5m2!1sen!2sin"
    allowfullscreen=""
    aria-hidden="false"
    tabindex="0">
  </iframe>
  </div>
  </div>
    </div>
  )
}
